export const tableHeaders = {
    CREATED_BY : 'Created By',
    CREATED_DATE : 'Created Date',
    UPDATED_BY : 'Updated By',
    UPDATED_DATE : 'Updated Date',
    EDIT_DELETE : 'Edit / Delete',
    CREATED_ON : 'Created On',
    UPDATED_ON : 'Updated On'
}

export const tableMessage = {
    NO_RECORD : 'No Record(s) Found'
}